"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconPrint = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 20 20",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M14.9983 2.5 14.9983 6.6667 15.8317 6.6667C17.215 6.6667 18.3317 7.7833 18.3317 9.1667L18.3317 9.1667 18.3317 14.1667 14.9983 14.1667 14.9983 17.5 4.9983 17.5 4.9983 14.1667 1.665 14.1667 1.665 9.1667C1.665 7.7833 2.7817 6.6667 4.165 6.6667L4.165 6.6667 4.9983 6.6667 4.9983 2.5 14.9983 2.5ZM13.3317 12.5 6.665 12.5 6.665 15.8333 13.3317 15.8333 13.3317 12.5ZM15.8317 8.3333 4.165 8.3333C3.7067 8.3333 3.3317 8.7083 3.3317 9.1667L3.3317 9.1667 3.3317 12.5 4.9983 12.5 4.9983 10.8333 14.9983 10.8333 14.9983 12.5 16.665 12.5 16.665 9.1667C16.665 8.7083 16.29 8.3333 15.8317 8.3333L15.8317 8.3333ZM14.9983 8.75C15.4586 8.75 15.8317 9.1231 15.8317 9.5833 15.8317 10.0436 15.4586 10.4167 14.9983 10.4167 14.5381 10.4167 14.165 10.0436 14.165 9.5833 14.165 9.1231 14.5381 8.75 14.9983 8.75ZM13.3317 4.1667 6.665 4.1667 6.665 6.6667 13.3317 6.6667 13.3317 4.1667Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconPrint')(IconPrint);